import settings from 'shared/settings';

import WixSDK from 'shared/utils/wix-sdk';
import http from 'shared/utils/http';

import { COLLECTOR_SERVICE } from 'shared/constants/stats/endpoints-url';
import { buildReport } from 'shared/constants/stats/events';

import createAsyncActions from 'shared/redux/helpers/create-async-actions';


const { statsCollector } = settings.hosts;
const reportUrl = `${statsCollector}${COLLECTOR_SERVICE}`;

const ACTIONS = createAsyncActions('SERVER.STATS.REPORT');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;

export default function (event, eventData) {
  return function (dispatch) {
    dispatch(START());

    const analytics = { analytics: { type: 'error', name: 'widget.stats.report' } };

    return WixSDK.getCtToken()
      .then(ctToken => {
        const data = buildReport(event, eventData);

        return http
          .post(reportUrl, {
            params: {
              ctToken,
            },
            options: {
              headers: {
                'Content-Type': 'application/json',
              },
            },
            data,
          })
          .then(result => {
            if (!_.get(result, 'data.success')) {
              return Promise.reject(result);
            }

            dispatch(SUCCESS(data, result));
          })
          .catch(error => {
            dispatch(FAIL(data, error, analytics));
          });
      })
      .catch(() => {
        dispatch(FAIL({ event, eventData }, null, analytics));
      });
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/server/actions/stats/report.js